<template>
    <div class="help_page">
        <h1 class="title">{{ $t('contactUs') }}</h1>
        <p>{{ $t('helpPageDesc') }}</p>
        <p>{{ $t('Email') }}:&nbsp;fogotv4k@gmail.com</p>
        <a :href="mailtoLink" class="email-button">
            <el-button icon="el-icon-edit" type="primary">{{
                $t('quickFeedback')
            }}</el-button>
        </a>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    computed: {
        mailtoLink() {
            const email = 'fogotv4k@gmail.com'
            const subject = encodeURIComponent('Issue')
            const body = encodeURIComponent('Please describe your issue here.')
            return `mailto:${email}?subject=${subject}&body=${body}`
        }
    }
}
</script>